import { useGetReservationsQuery } from "@stepapp/core";
import { BottomSheet, spacing } from "@stepapp/ui";
import { useCallback, useMemo, useState } from "react";
import { StyleSheet } from "react-native";
import { ServiceList } from "../../src/components";
import { useFindServicesForReview, useSortOrders } from "../../src/hooks";
import { RetryPayment } from "../../src/screens";
import { AppStorage } from "../../src/services/AppStorage";
import { ReservationActiveStatuses } from "../../src/store/types";

const Calendar = () => {
  const isAuthenticated = !!AppStorage().get("token");
  const [updateServiceId, setUpdateServiceId] = useState("");
  const [paymentMethodId, setPaymentMethodId] = useState("");

  const {
    data,
    loading,
    refetch: refetchReservations,
  } = useGetReservationsQuery({
    fetchPolicy: "network-only",
    variables: { filter: { status: ReservationActiveStatuses }, isCustomerApp: true },
    skip: !isAuthenticated,
  });

  const { servicesForReview, servicesToRetryPayment } = useFindServicesForReview();

  const orders = useSortOrders(data?.listReservations);
  const reviewOrders = useSortOrders(servicesForReview);
  const retryPaymentOrders = useSortOrders(servicesToRetryPayment);

  const ordersList = useMemo(
    () => (loading ? [] : [...retryPaymentOrders, ...reviewOrders, ...orders]),
    [retryPaymentOrders, reviewOrders, orders, loading],
  );

  const orderToUpdatePayment = useMemo(
    () => servicesToRetryPayment?.find((service) => service.id === updateServiceId),
    [servicesToRetryPayment, updateServiceId],
  );

  const handleClose = useCallback(() => {
    setPaymentMethodId("");
    setUpdateServiceId("");
  }, []);

  return (
    <>
      <ServiceList
        isCalendarScreen
        orders={ordersList}
        refetchReservations={refetchReservations}
        setUpdateServiceId={setUpdateServiceId}
        setSelectPaymentMethod={setPaymentMethodId}
        loading={loading}
      />

      <BottomSheet
        contentStyle={styles.retryPaymentModal}
        toggle={handleClose}
        visible={!!updateServiceId}
      >
        <RetryPayment
          onClose={handleClose}
          selectPaymentMethod={setPaymentMethodId}
          price={orderToUpdatePayment?.price}
          currency={orderToUpdatePayment?.currency}
          paymentId={orderToUpdatePayment?.payment?.id || ""}
          paymentMethodId={paymentMethodId}
          reservationId={orderToUpdatePayment?.id || ""}
        />
      </BottomSheet>
    </>
  );
};

export default Calendar;

const styles = StyleSheet.create({
  retryPaymentModal: {
    padding: spacing.unit * 2.5,
  },
});
